import { WCCSliderItemState } from 'components/slider/enums/itemState';
import { wccModules } from "enums/wccModules";
import { inject, injectable } from "inversify";
import { Observable, Subscribable } from "knockout";
import { NodeTracker } from "managers/nodes/tracker";
import { EffectsContainer } from "mixins/withEffects";
import WCCSliderItem from "./base.model";
import './base.scss';

@injectable()
export default class WCCSliderItemVM<T> {
    data: Observable<T>

    opacity: Observable<number>
    offset: Observable<number>

    paddingLeft: Observable<number>
    paddingRight: Observable<number>
    marginLeft: Observable<number>
    marginRight: Observable<number>

    height: Subscribable<number>

    isActive: Subscribable<boolean>
    isInactive: Subscribable<boolean>
    isShifted: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) private model: WCCSliderItem<T>,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.data = model.data;

        this.opacity = model.opacity;
        this.offset = model.offset;

        this.isActive = model.isActive;
        this.isInactive = model.isActive.not();

        const tracker = new NodeTracker({ node: <HTMLElement>info.element });
        this.height = tracker.height;

        this.paddingLeft = model.paddingLeft;
        this.paddingRight = model.paddingRight;
        this.marginLeft = model.marginLeft;
        this.marginRight = model.marginRight;

        this.isShifted = this.offset.is(offset => offset > 0);

        effects.saveState(model.height);

        effects.register(height => {
            model.height(height);
        }, [this.height]);

        ko.applyBindingsToNode(info.element, {
            'translate': { x: this.offset },

            'css': {
                'wcc-animated fadeIn': true,
                'wcc-slider__item': true,
                'wcc-slider__item--shifted': this.isShifted,
                'wcc-slider__item--inactive': this.isInactive                
            },

            'style': {
                'opacity': this.opacity,
                'padding-left': this.paddingLeft.toPx(),
                'padding-right': this.paddingRight.toPx(),
                'margin-left': this.marginLeft.toPx(),
                'margin-right': this.marginRight.toPx()
            },

            'attr': {
                'dir': ko.pureComputed(() => settings.isRTL() ? 'rtl' : 'ltr')
            }
        });
    }

    init() {
        requestAnimationFrame(() => {
            this.model.state(WCCSliderItemState.active);
        });
    }
}